<div class="p-0 lg:p-4 min-h-96 mb-20">
  <app-nav-button [route]="routeBack"></app-nav-button>
  <div *ngIf="!isLoading && packages.length > 0" class="text-center mb-14">
    <h2 class="text-3xl font-bold text-gray-900">Paquetes disponibles</h2>
    <p class="text-gray-500 mt-2">
      Elige el paquete que mejor se adapte a tus necesidades.
    </p>
  </div>
  <app-loading [text]="'Cargando paquetes'" *ngIf="isLoading"></app-loading>
  <div
    *ngIf="!isLoading && packages.length > 0"
    class="flex flex-col space-y-6 md:grid md:grid-cols-3 md:gap-6 px-4 sm:px-0"
  >
    <div
      *ngFor="let pkg of packages"
      class="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 transform transition duration-300 md:hover:scale-105 md:hover:border-primary w-full md:w-auto shrink-0"
    >
      <div class="flex flex-col lg:flex-row items-center justify-center mb-6">
        <div class="bg-light text-primary rounded-lg p-3 mr-2">
          <ng-icon name="featherBox" size="28"></ng-icon>
        </div>
        <h3 class="text-xl font-bold text-gray-800">{{ pkg.name }}</h3>
      </div>
      <div class="mb-6">
        <span class="text-xl lg:text-3xl font-bold text-primary">{{
          pkg.price | solesCurrency
        }}</span>
        <span class="text-gray-500 text-sm ml-1">/anual</span>
      </div>
      <div class="space-y-3 mb-8">
        <div class="flex items-center gap-3 border-b border-gray-100 pb-2">
          <span class="text-gray-800 text-sm font-semibold">
            Número de publicaciones anuales :
            <span class="text-primary">{{ pkg.postMontQuantity }}</span>
          </span>
        </div>
        <div class="flex items-center gap-3 border-b border-gray-100 pb-2">
          <span class="text-gray-800 text-sm font-semibold">
            Días en banner superior :
            <span class="text-primary">{{ pkg.daysQuantityNoticeHome }}</span>
          </span>
        </div>
        <div
          class="flex items-center gap-3 border-b border-gray-100 pb-2"
          *ngFor="
            let feature of [
              {
                label: 'Acceso directo a CV',

                value: pkg.fileAccessMonthQuantity
              },

              { label: 'Banner marca', value: pkg.bannerBrand },

              { label: 'IGV incluido', value: pkg.igv },

              {
                label: 'Notificación por correo',

                value: pkg.postulantEmailSendQuantity
              },

              { label: 'Portal web', value: pkg.webPortal },

              { label: 'Capacitación uso de codijobs', value: pkg.training },

              { label: 'Banner publicidad', value: pkg.bannerSponsor },

              {
                label: 'Aparición en ofertas destacadas',

                value: pkg.featuredJobOffer
              }
            ]
          "
        >
          <div
            class="flex items-center justify-center w-6 h-6 rounded text-primary overflow-hidden"
          >
            <ng-container *ngIf="feature.value == '1'; else notIncluded">
              <ng-icon name="featherCheck" size="20"></ng-icon>
            </ng-container>
            <ng-template #notIncluded>
              <div
                class="w-full h-full text-red-600 flex items-center justify-center"
              >
                <ng-icon name="featherX" size="20"></ng-icon>
              </div>
            </ng-template>
          </div>
          <span
            class="text-sm transition-colors"
            [ngClass]="{
              'text-gray-800': feature.value == '1',
              'text-gray-500': feature.value == '0'
            }"
          >
            {{ feature.label }}
          </span>
        </div>
      </div>

      <div class="text-center">
        <button
          (click)="openModal(pkg)"
          class="bg-primary hover:bg-primary/90 text-white px-6 py-2 rounded-lg font-semibold transition w-full"
        >
          Obtenerlo
        </button>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="showModal"
  class="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
>
  <div class="bg-white p-6 rounded shadow-md w-96">
    <h3 class="text-lg font-bold mb-4">Adquirir paquete</h3>
    <p>¿Deseas adquirir el paquete {{ selectedPackage.name }}?</p>
    <div class="mt-4 flex justify-end gap-2">
      <button class="px-4 py-2 bg-gray-300 rounded" (click)="closeModal()">
        Cancelar
      </button>
      <app-loading-button
        (click)="confirmAcquisition()"
        [text]="'Confirmar'"
        [loading]="isLoadingPackage"
        type="button"
      >
      </app-loading-button>
    </div>
  </div>
</div>
